import { type ReactNode } from "react";
import { ErrorPage } from "@fwa/src/components/ErrorPage";
import { type ResponseError } from "@fwa/src/types";

type Props = {
  error?: Error | ResponseError;
  children: ReactNode;
};

export const ErrorPageWrapper = ({ error, children }: Props) =>
  typeof error !== "undefined" && !!error ? (
    <ErrorPage
      statusCode={
        error && "status" in error && error.status ? error.status : 500
      }
      error={error}
    />
  ) : (
    <>{children}</>
  );

export default ErrorPageWrapper;
